import React from "react";
import { graphql } from "gatsby";
import { PrismicRichText } from "@prismicio/react";
import { motion } from "framer-motion";

import {
  ActiveSlideProvider,
  useActiveSlide,
} from "../../context/active-slide-context";
import PhoneCarousel from "../../components/PhoneCarousel";
import SocialVideo from "../../components/SocialVideo";
import SocialImage from "../../components/SocialImage";

import * as styles from "./collabs.module.css";

const PartnerLogos = ({ slice }) => {
  const { activeIndex } = useActiveSlide();
  const currentItem = slice.items[activeIndex];
  const bgColor = currentItem?.partner_logo_background || "#ffffff";
  const transitionDuration = 0.35;

  return (
    <div className={styles.brands}>
      <motion.div
        className={styles.brandsInner}
        animate={{ backgroundColor: bgColor }}
        transition={{ duration: transitionDuration, ease: "easeInOut" }}
      >
        {slice.items.map((item, index) => (
          <motion.img
            key={item.partner_logo.url}
            src={item.partner_logo.url}
            alt=""
            initial={false}
            animate={{ opacity: index === activeIndex ? 1 : 0 }}
            transition={{ duration: transitionDuration, ease: "easeInOut" }}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        ))}
      </motion.div>
    </div>
  );
};

export const Collabs = ({ slice }) => {
  const { heading, copy } = slice?.primary || {};

  return (
    <ActiveSlideProvider>
      <section
        data-color-scheme="black"
        data-highlight-background="aqua"
        data-highlight-foreground="black"
        data-tilt-scheme="left"
        style={{ position: "relative", isolation: "isolate" }}
        id="collabs"
      >
        <div className="section-split-6-5 page-width padding-section-vertical">
          <div className={styles.content}>
            {heading && (
              <PrismicRichText
                field={heading.richText}
                components={{
                  heading2: ({ children }) => (
                    <h2 className="h2">{children}</h2>
                  ),
                  strong: ({ children }) => <small>{children}</small>,
                }}
              />
            )}
            {copy && <PrismicRichText field={copy.richText} />}
          </div>
          <div className={styles.carousel}>
            <PhoneCarousel autoplay>
              {slice.items?.map(({ video, image, collab_info }, index) => {
                if (video) {
                  return (
                    <SocialVideo key={video.url} index={index} url={video.url}>
                      {collab_info && (
                        <PrismicRichText field={collab_info.richText} />
                      )}
                    </SocialVideo>
                  );
                } else if (image) {
                  return (
                    <SocialImage
                      image={image.gatsbyImageData}
                      alt={image.alt || ""}
                      key={image.url}
                    >
                      {collab_info && (
                        <PrismicRichText
                          field={collab_info.richText}
                          components={{
                            paragraph: ({ children }) => (
                              <p className={styles.videoInfo}>{children}</p>
                            ),
                          }}
                        />
                      )}
                    </SocialImage>
                  );
                }
                return null;
              })}
            </PhoneCarousel>
            <PartnerLogos slice={slice} />
          </div>
        </div>
      </section>
    </ActiveSlideProvider>
  );
};

export const query = graphql`
  fragment HomepageDataBodyCollabs on PrismicHomepageDataBodyCollabs {
    primary {
      heading {
        richText
      }
      copy {
        richText
      }
    }
    items {
      video {
        id
        url
      }
      image {
        gatsbyImageData(placeholder: BLURRED)
        url
        alt
      }
      partner_logo {
        gatsbyImageData(placeholder: BLURRED)
        url
        alt
      }
      partner_logo_background
      collab_info {
        richText
      }
    }
  }
`;
